import {inject, InjectionToken} from "@angular/core";
import {ErrorMessageGeneratorService} from "./error-message-generator.service";


export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => inject(ErrorMessageGeneratorService).defaultErrors
});

